import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import TextArea from "../../../components/form-controls/TextArea"
import Select from 'react-select'
import Input from "../../../components/form-controls/Input";
import { useEffect, useState  } from "react";
import { AlertService } from "../../../services/Alert";
import { MetaService } from "../../../services/MetaService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import QuickReplyBtn from "./QuickReplyBtn";
import UrlBtn from "./UrlBtn";

function Step2Partial({ isValidForm, onChange }) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    
    const defaultHeaderValues = {
        type: 'HEADER',
        format: {
            value: 'none',
            label: t("platform.channels.templates.none-label")
        },
        text: '',
        content: {
            value: '',
            label: ''
        },
        file: '',
        example: {
            header_handle: ''
        },
        url: ''
    }
    const defaultBodyValues = {
        type: 'BODY',
        text: '',
        example: {
            body_text: []
        }
    }
    const defaultFooterValues = {
        type: 'FOOTER',
        text: '',
    }
    
    const defaultButtonValues = {
        type: '',
        text: '',
        url: '',
        style: '', // dynamic o static
        example: '',
    }
    const defaultButtonsValues = {
        type: 'BUTTONS',
        buttons: [],
    }
    const defaultValues = {
        header: defaultHeaderValues,
        body: defaultBodyValues,
        footer: defaultFooterValues,
        buttons: defaultButtonsValues,
    }

    const [canBtnBlacklist, setCanBtnBlacklist] = useState(false);
    

    const { control, register, watch, setValue, formState: { errors, isValid } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const form = useWatch({ control })

    const bodyVars = useFieldArray({
        control, 
        name: "body.example.body_text", 
    });

    const buttonActionsArray = useFieldArray({
        control, 
        name: "buttons.buttons",
    });

    const header = watch('header');
    const body = watch('body.text');
    const footer = watch('footer.text');
    const buttons = watch('buttons');


    const uploadFile = async({ target: { files }}) => {
        const bytesToMegabytes = (bytes) => {
            const megabytes = bytes / (1024 * 1024);
            return megabytes.toFixed(2);
        }

        const file = files[0];
        const sizeMB = +bytesToMegabytes(file.size);
        const type = header.content.value;

        if(sizeMB > 5) {
            AlertService.toastError('Sólo se permiten archivos de máximo 5MB')
            setValue('header.file', '')
            return;
        }

        if(type === 'image' && (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png')) {
            AlertService.toastError('Sólo se permiten imagenes en formato png o jpg')
            setValue('header.file', '')
            return;
        }
        if(type === 'video' && file.type !== 'video/mp4' ) {
            AlertService.toastError('Sólo se permiten videos en formato mp4')
            setValue('header.file', '')
            return;
        }
        if(type === 'document' && file.type !== 'application/pdf' ) {
            AlertService.toastError('Sólo se permiten archivos en formato PDF')
            setValue('header.file', '')
            return;
        }
       

        const promise = async() => {
            const data = new FormData();
            data.append('file', file)
            data.append('account_id', account.id)
            const response = await MetaService.uploadMedia(data)
            // response.data.url
            // response.data.metaID
            setValue('header.example.header_handle', response.data.metaID)
            setValue('header.url', response.data.url)
        }

        AlertService.toastLoading( promise(), 'Guardando archivo...', 'El archivo se guardó correctamente', 'Ocurrió un error al guardar el archivo, intenta nuevamente' )

    }

    const addBtn = (type: string) => {
        buttonActionsArray.append({
            ...defaultButtonValues, 
            type,
            is_btn_blacklist: false
        })
    }


    useEffect(() => {
        const match = body.match(/{{\d+}}/g);
        if(!match) return bodyVars.replace([]);

        let tokens = match.map( t => t.replace(/{{|}}/gi, ""))
        tokens = tokens.filter((x, i, a) => a.indexOf(x) == i)

        bodyVars.replace(tokens.map( t => ({ key: t, value: '' })))
    }, [body])
    
    useEffect(() => {
        isValidForm(isValid)
    }, [isValid])

    useEffect(() => {
        onChange(form)

        const exists = form.buttons.buttons.find( (b) => b.type === 'QUICK_REPLY_DISABLE_MKT' );
        setCanBtnBlacklist(exists ? true: false)

    }, [form])

    useEffect(() => {
        setValue('header.file', '')
    }, [header.content.value])


    return (
        <>
            <div className="row ">
                <div className="col-8">
                    <div className="card ">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.header")} <span className="badge bg-soft-secondary text-secondary">{t("platform.channels.templates.optional-label")}</span></h2>
                            <p className="small ">
                            {t("platform.channels.templates.header-text")}
                            </p>

                            <div className="row">
                                <div className=" col-6">
                                    <Controller
                                        control={control}
                                        name='header.format'
                                        rules={{ required: true }}
                                        render={
                                            ({
                                                field: { onChange, value }                                            }) => (
                                                <Select
                                                    options={[
                                                        { value: 'none', label: t("platform.channels.templates.none-label") },
                                                        { value: 'text', label: t("platform.channels.templates.message-text-label") },
                                                        { value: 'media', label: t("platform.channels.templates.media") },
                                                    ]}
                                                    className={'form-select-custom ' }
                                                    classNamePrefix='form-select-custom'
                                                    placeholder='Tipo de encabezado'
                                                    onChange={(data: any) => onChange(data)}
                                                    value={value as any}
                                                />
                                            )
                                        }
                                    />
                                </div>
                                {
                                    header.format.value === 'text' && (
                                        <div className=" col-6">
                                           <Input
                                                {...register('header.text', { required: true, maxLength: { value: 60, message: '60' } })}
                                                errors={errors.header?.text} 
                                                currentLength={header.text.length}
                                                maxLength={60}
                                            />
                                        </div>
                                    )
                                }
                                {
                                    header.format.value === 'media' && (
                                        <div className=" col-6">
                                             <Controller
                                                control={control}
                                                name='header.content.value'
                                                rules={{ required: true }}
                                                render={
                                                    ({
                                                        field: { onChange, value }                                                    }) => {
                                                        const options = [
                                                            { value: 'image', label: t("platform.channels.templates.image") },
                                                            { value: 'video', label: t("platform.channels.templates.video")  },
                                                            { value: 'document', label: t("platform.channels.templates.pdf")  },
                                                        ]

                                                        return (
                                                            <Select
                                                                options={options}
                                                                className={'form-select-custom ' }
                                                                classNamePrefix='form-select-custom'
                                                                placeholder= {t("platform.channels.templates.type-content")}
                                                                onChange={(data: any) => onChange(data.value)}
                                                                value={options.find( o => o.value === value)}
                                                            />
                                                        )
                                                    }
                                                }
                                            />
                                        </div>
                                    )
                                }
                                
                            </div>

                            {
                                header.format.value === 'media' && header.content.value && (
                                    <div className="row mt-3">
                                        <div className="col">
                                            <div className="alert alert-soft-secondary" role="alert">
                                                <h5>{t("platform.channels.templates.content-label")}</h5>
                                                <p>{t("platform.channels.templates.content-p")}</p>
                                                <div>
                                                    <Input
                                                        label={header.content.value === 'image' ? t("platform.channels.templates.image"): header.content.value === 'video'? t("platform.channels.templates.video"): t("platform.channels.templates.pdf") }
                                                        type='file'
                                                        errors={errors.header?.file} 
                                                        {...register('header.file', { required: true, onChange: uploadFile })}
                                                        sizeClass='form-control-sm'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            
                        </div>
                    </div>
                    <hr />

                    <div className="card ">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.text-label")}</h2>
                            <p className="small ">
                            {t("platform.channels.templates.text-p")}
                            </p>

                            <div className="mb-3">
                                <TextArea
                                    errors={errors.body?.text }
                                    value={watch('body.text').length}
                                    counter={1024}
                                    {...register('body.text', { required: true, maxLength: { value: 1024, message: '1024' } })} />

                            </div>

                            {
                                bodyVars.fields.length > 0 && (
                                    <div className="mb-3">
                                        <div className="alert alert-soft-secondary" role="alert">
                                            <h5>Ejemplos de contenido del cuerpo</h5>
                                            <p>Agrega un ejemplo en cada variable del texto del cuerpo para que META pueda revisar tu plantilla de mensaje. No uses información verdadera de clientes. La API de la nube, alojada por Meta, revisa las plantillas y los parámetros de las variables para garantizar la seguridad e integridad de nuestros servicios.</p>

                                            <h6>Texto</h6>
                                            {
                                                bodyVars.fields.map( (row, index) => (
                                                    <div className="d-flex align-items-center mb-2" key={row.id}>
                                                        <label className="form-label mx-3" >{`{{${watch(`body.example.body_text.${index}.key`)}}}`}</label>
                                                        <div className="flex-grow-1">
                                                            <Input
                                                                errors={errors.body?.example?.body_text?.[index] } {...register(`body.example.body_text.${index}.value`, { required: true })}
                                                                sizeClass='form-control-sm'
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>  
                                )
                            }
                                                     
                            
                        </div>
                    </div>
                    <hr />

                    <div className="card">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.footer")} <span className="badge bg-soft-secondary text-secondary">{t("platform.channels.templates.optional-label")}</span></h2>
                            <p className="small ">
                            {t("platform.channels.templates.footer-p")}
                            </p>

                            <div className="mb-3">
                                <Input
                                    errors={errors.footer?.text} {...register('footer.text', { maxLength: { value: 60, message: '60' }, setValueAs: (value) => value.trim() })}
                                    currentLength={watch('footer.text').length}
                                    maxLength={60}
                                />
                            </div>
                        </div>
                    </div>
                    <hr />
                    
                    <div className="card">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.btn-label")} <span className="badge bg-soft-secondary text-secondary">{t("platform.channels.templates.optional-label")}</span></h2>
                            <p className="small ">
                            {t("platform.channels.templates.btn-p")}
                            </p>

                            <div className="row">
                                <div className=" col-12">
                                    <div className="dropdown">
                                        <button className="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="bi-plus-lg"></i>{t("platform.channels.templates.add-btn")}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button className="dropdown-item" onClick={() => addBtn('QUICK_REPLY')}>{t("platform.channels.templates.quick-response")}</button>
                                            <button className="dropdown-item" onClick={() => addBtn('QUICK_REPLY_DISABLE_MKT')} disabled={canBtnBlacklist}>Desactivar envio de plantillas</button>
                                            <button className="dropdown-item" onClick={() => addBtn('URL')}>
                                                Ir al sitio web (2 botones como máximo)
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            {
                                ( buttonActionsArray.fields.length > 0 ) && (
                                    <div className="row  mb-3">
                                        <div className="col">
                                            {
                                                buttonActionsArray.fields.map( (row, index) => (

                                                    <div key={row.id}>
                                                        {
                                                            row.type === 'QUICK_REPLY' && (
                                                                <QuickReplyBtn 
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                    type={row.type}
                                                                />
                                                            )
                                                        }
                                                        {
                                                            row.type === 'QUICK_REPLY_DISABLE_MKT' && (
                                                                <QuickReplyBtn 
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                    type={row.type}
                                                                />
                                                            )
                                                        }
                                                        {
                                                            row.type === 'URL' && (
                                                                <UrlBtn 
                                                                    errors={errors.buttons?.buttons?.[index]}
                                                                    register={register}
                                                                    index={index}
                                                                    watch={watch}
                                                                    onDelete={() => buttonActionsArray.remove(index)}
                                                                />
                                                            )
                                                        }
                                                    </div>

                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }
                            
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div className="bg-whatsapp p-4 rounded shadow-sm border h-100 ">
                        <div className="sticky">
                            <h4>Vista previa</h4>

                            <div className="mt-3 ">
                                <div className="preview-template">
                                    
                                    
                                    { header.format.value === 'text' &&  <div className="preview-template-header">{header.text}</div> }
                                    { header.format.value === 'media' && header.content.value === 'image' &&  <div className="preview-template-header"><div className="preview-template-image" style={{ backgroundImage: `url(${header.url})`}}>{ !header.url && <i className="bi-card-image"></i> }</div></div> }
                                    { header.format.value === 'media' && header.content.value === 'video' &&  <div className="preview-template-header"> <div className="preview-template-video" > <i className="bi-play-circle-fill"></i></div> </div> }
                                    { header.format.value === 'media' && header.content.value === 'document' &&  <div className="preview-template-header"> <div className="preview-template-video" > <i className="bi-filetype-pdf"></i></div> </div> }
                                    <div dangerouslySetInnerHTML={{__html: body.replace(/\n/g, '<br/>') }}></div>
                                    {footer && <div className="preview-template-footer">{footer}</div>}
                                </div>

                                {
                                    buttons.buttons.map( (btn, index) => (
                                        <div key={index} className="preview-template preview-template-btn">
                                            { btn.type === 'URL' && <><i className="bi bi-box-arrow-up-right"></i> {btn.text}</>}
                                            { btn.type === 'QUICK_REPLY' && <><i className="bi bi-reply"></i> {btn.text}</>}
                                            { btn.type === 'QUICK_REPLY_DISABLE_MKT' && <><i className="bi bi-reply"></i> {btn.text}</>}
                                        </div>)
                                    )
                                }
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}
export default Step2Partial